// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2o7N2","title":"Info_title__2Yktv","selects":"Info_selects__1QpUE","requiredAsterisk":"Info_requiredAsterisk__sZTMu"};